import api from './api';

/**
 * Fetch the member's current reset path (comfort zones + activities).
 * Returns { path, activities }
 */
export const getResetPath = async () => {
  const { data } = await api.get('/reset-path');
  return data;
};

/**
 * Save comfort zones and priority order.
 * Expects the full payload with all 12 comfort zone fields + priority_sectors.
 */
export const saveComfortZones = async (payload) => {
  const { data } = await api.post('/reset-path', payload);
  return data;
};

/**
 * Fetch all planned activities (active only by default).
 */
export const getActivities = async (activeOnly = true) => {
  const { data } = await api.get('/reset-path/activities', {
    params: { active: activeOnly ? 'true' : 'false' },
  });
  return data;
};

/**
 * Add a planned activity.
 * @param {{ sector, activity_name, frequency, target_count }} activity
 */
export const addActivity = async (activity) => {
  const { data } = await api.post('/reset-path/activities', activity);
  return data;
};

/**
 * Update a planned activity.
 */
export const updateActivity = async (id, fields) => {
  const { data } = await api.put(`/reset-path/activities/${id}`, fields);
  return data;
};

/**
 * Soft-delete a planned activity (sets is_active = false).
 */
export const deleteActivity = async (id) => {
  const { data } = await api.delete(`/reset-path/activities/${id}`);
  return data;
};

/**
 * Mark onboarding complete and advance member to 'active' phase.
 */
export const completeOnboarding = async () => {
  const { data } = await api.post('/reset-path/complete-onboarding');
  return data;
};

/**
 * Update item arrays (and optionally focus) for a single sector.
 */
export const updateSectorItems = (data) =>
  api.put('/reset-path/sector-items', data).then(r => r.data);

/**
 * Get the member's overall focus + all sector focuses.
 */
export const getMemberFocus = () =>
  api.get('/reset-path/focus').then(r => r.data);

/**
 * Update the overall member_focus field.
 */
export const updateMemberFocus = (data) =>
  api.put('/reset-path/focus', data).then(r => r.data);

/**
 * Pin or unpin a milestone as the dashboard focus.
 * Pass milestone_id: null to unpin.
 */
export const setFocusMilestone = (milestone_id) =>
  api.put('/reset-path/focus-milestone', { milestone_id }).then(r => r.data);
